// extracted by mini-css-extract-plugin
export default {"meinian-nest-menu":"index_meinian-nest-menu__0yHNM"};